module.exports = __webpack_public_path__ + "img/hugh-pindur-pindurski-dying-wish-final.3fb250cf.jpg";